import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  VStack,
} from "@chakra-ui/react";
import useEvmLogin from "~/hooks/useEvmLogin";
import useFlowLogin from "~/hooks/useFlowLogin";
import useSolanaLogin from "~/hooks/useSolanaLogin";
import EmailModal from "./EmailModal";

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function LoginModal({ isOpen, onClose }: LoginModalProps) {
  const { evmLogin, evmLoading, evmElement } = useEvmLogin();
  const { flowLogin, flowLoading } = useFlowLogin();
  const { solanaLogin, solanaLoading, solanaElement } = useSolanaLogin();
  const {
    isOpen: isEmailModalOpen,
    onOpen: onEmailModalOpen,
    onClose: onEmailModalClose,
  } = useDisclosure();

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select Login / Register Method</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4}>
              <Button
                w={"full"}
                variant="outline"
                onClick={() => {
                  onClose();
                  onEmailModalOpen();
                }}
              >
                Email
              </Button>
              <Button
                w={"full"}
                variant="outline"
                onClick={() => {
                  onClose();
                  evmLogin("login", "ethereum");
                }}
                isLoading={evmLoading}
              >
                Ethereum
              </Button>
              <Button
                w={"full"}
                variant="outline"
                onClick={() => {
                  onClose();
                  solanaLogin("login");
                }}
                isLoading={solanaLoading}
              >
                Solana
              </Button>
              <Button
                w={"full"}
                variant="outline"
                onClick={() => {
                  onClose();
                  flowLogin("login");
                }}
                isLoading={flowLoading}
              >
                Flow
              </Button>
              <Button
                w={"full"}
                variant="outline"
                onClick={() => {
                  onClose();
                  evmLogin("login", "polygon");
                }}
                isLoading={evmLoading}
              >
                Polygon
              </Button>
              <Button
                w={"full"}
                variant="outline"
                onClick={() => {
                  onClose();
                  evmLogin("login", "avalanche");
                }}
                isLoading={evmLoading}
              >
                Avalanche
              </Button>
              <Button
                w={"full"}
                variant="outline"
                onClick={() => {
                  onClose();
                  evmLogin("login", "klaytn");
                }}
                isLoading={evmLoading}
              >
                Klaytn
              </Button>
            </VStack>
          </ModalBody>

          <ModalFooter />
        </ModalContent>
      </Modal>
      {solanaElement}
      {evmElement}
      <EmailModal isOpen={isEmailModalOpen} onClose={onEmailModalClose} />
    </>
  );
}
